import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';

const VERSIONS_TO_FORCE_UPDATE = [
    '2.55',
    '2.57',
    '2.59',
    '2.60',
    '3.09',
    '3.10',
    '3.11',
    '3.14',
    '3.15',
];

export const forceVersionUpdateCondition = () => {
    const liteAppDetail = getMiniHostAppDetail();
    for (let i = 0; i < VERSIONS_TO_FORCE_UPDATE.length; i++) {
        if (liteAppDetail?.appVersionName?.includes(VERSIONS_TO_FORCE_UPDATE[i])) {
            return true;
        }
    }

    return false;
};
